// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"387":"3aa0178e","3411":"3aa0178e","3613":"3aa0178e","3822":"3aa0178e","7742":"71dcd781"}[chunkId] + ".chunk.css";
};